import { styled } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { HeadingM, BodyTextM } from "./Typography";

export const HelpAlert = styled(Alert)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row-reverse",
        py: 3,
        px: 4,
        boxShadow: "far",
        border: "1px solid",
        borderColor: "grey.light",
        bgcolor: "white.main",
        ".MuiAlert-message": { flexGrow: 1 },
    }),
);

export const HelpHeading = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
    }),
);

export const HelpHeadingRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        width: "100%",
        gap: 2,
    }),
);

export const HelpText = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        color: "grey.dark",
    }),
);

export const HelpLink = styled("a")({
    color: "#EA650D",
    fontWeight: 600,
    textDecoration: "none",
});

export const HelpIconImage = styled("img")({
    width: 80,
    height: "auto",
    objectFit: "contain",
});

export const HelpContentStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 2,
    }),
);
